import useCountdown from '../../utils/useCountdown';
import CountdownBoxes from './CountdownBoxes';

const Countdown = ({ attributes, Box, closeEl, isBackend = false, custom = {}, children }) => {
	const { destDate, isResponsive, isExpired, prefixText, suffixButtonText, suffixButtonUrl, addID, addClass, isDismiss } = attributes;

	const destTime = new Date(destDate).getTime();
	const { expired } = useCountdown(destTime);

	return <div className={`ctbCountdownTime ${addClass}`} id={addID}>
		{isExpired && expired ? children : <>
			{prefixText && <p className='prefixText' dangerouslySetInnerHTML={{ __html: prefixText }} />}

			<div className={`countdownItems ${isResponsive ? 'ctbResponsive' : ''}`}>
				<CountdownBoxes attributes={attributes} Box={Box} isBackend={isBackend} custom={custom} />
			</div>

			{suffixButtonText && <a className='suffixButton' href={suffixButtonUrl}>{suffixButtonText}</a>}
		</>}

		{isDismiss && closeEl}
	</div>
}
export default Countdown;